<template>
  <Modal
    v-if="accountSuspended"
    ref="modal"
    v-model:open="open"
    :title="t('account_suspended')"
    :click-to-close="false"
    :esc-to-close="false"
    max-width="476px"
    max-height="80vh"
    width="90vw"
  >
    <div>{{ t("account_suspended_message") }}</div>
    <template #footer>
      <ModalFooter>
        <template #actions>
          <Button :variant="ButtonVariant.Secondary" class="w-full sm:w-fit" @click="open = false">
            {{ t("close") }}
          </Button>
        </template>
      </ModalFooter>
    </template>
  </Modal>
</template>

<script setup lang="ts">
  const { t } = useI18n();
  const open = ref(true);
  const { account } = useWorkspacesStore();
  const accountSuspended = ref(false);
  const route = useRoute();
  const suspendedPages = ["consignments", "shipments", "returns", "sortings", "tickets", "clickcollect"];
  watch(
    route,
    (newRoute) => {
      if (suspendedPages.includes(newRoute.name as string) && account && account.blocked) {
        accountSuspended.value = true;
        open.value = true;
      } else {
        accountSuspended.value = false;
        open.value = false;
      }
    },
    {
      immediate: true,
      deep: true,
    }
  );
</script>
